import { Settings, TriangleAlert } from 'lucide-react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { DeleteWebhookFallback } from '@/routes/webhook/tabs/overview/sections/danger-zone/delete-webhook/fallback'
import { ToggleWebhookFallback } from '@/routes/webhook/tabs/overview/sections/danger-zone/toggle-webhook/fallback'
import { WebhookAnalyticsSectionFallback } from '@/routes/webhook/tabs/overview/sections/general/analytics/fallback'
import { WebhookDetailsSectionFallback } from '@/routes/webhook/tabs/overview/sections/general/details/fallback'

export const OverviewTabFallback = () => {
  return (
    <div className="space-y-6 pb-25">
      <Card className="bg-secondary p-0 gap-0">
        <CardHeader className="px-5 pt-3 pb-1">
          <CardTitle>
            <H3 className="flex items-center gap-2 text-sm text-muted-foreground">
              <Settings className="size-4" /> General
            </H3>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Card className="p-0 border-x-0 border-b-0 shadow-none">
            <CardContent className="p-0 pb-6">
              <WebhookDetailsSectionFallback />
              <Separator className="w-full mt-6" />
              <WebhookAnalyticsSectionFallback />
            </CardContent>
          </Card>
        </CardContent>
      </Card>
      <Card className="bg-secondary p-0 gap-0">
        <CardHeader className="px-5 pt-3 pb-1">
          <CardTitle>
            <H3 className="flex items-center gap-2 text-sm text-destructive/80">
              <TriangleAlert className="size-4" /> Danger zone
            </H3>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Card className="p-0 border-x-0 border-b-0 shadow-none">
            <CardContent className="p-0 pb-6">
              <ToggleWebhookFallback />
              <Separator className="w-full mt-6" />
              <DeleteWebhookFallback />
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </div>
  )
}
